import React from "react";
import DateRangePickerComponent from "./DateRangePickerComponent";
import PropTypes from "prop-types";
import "./QuickAndFullRangeDatePicker.css"; // Reuse your styles

const QuickAndFullRangeDatePicker = ({ onDateChange, fullDataReset }) => {
  const handleQuickRange = (days) => {
    const end = new Date();
    const start = new Date();
    start.setDate(end.getDate() - (days - 1));
    onDateChange(start, end);
  };

  const handleDropdownSelect = (label) => {
    const end = new Date();
    let start = new Date();

    if (label === "6M") start.setMonth(end.getMonth() - 6);
    else if (label === "1Y") start.setFullYear(end.getFullYear() - 1);
    else if (label === "All") {
      start = new Date(0); // Unix epoch: Jan 1, 1970
      // OR: set to earliest known date in your dataset
      // fullDataReset(); // If you want to reset data
    }

    onDateChange(start, end);
  };

  return (
    <div className="date-controls">
      <div className="left-date-picker">
        <DateRangePickerComponent onDateChange={onDateChange} />
      </div>

      <div className="right-quick-buttons">
        {["7D", "30D", "3M"].map((label) => {
          const days = label === "7D" ? 7 : label === "30D" ? 30 : 90;
          return (
            <button
              key={label}
              className="quick-button"
              onClick={() => handleQuickRange(days)}
            >
              {label}
            </button>
          );
        })}

        <div className="dropdown">
          <button className="quick-button">...</button>
          <div className="dropdown-content">
            {["6M", "1Y", "All"].map((label) => (
              <div
                key={label}
                className="dropdown-item"
                onClick={() => handleDropdownSelect(label)}
              >
                {label}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

QuickAndFullRangeDatePicker.propTypes = {
  onDateChange: PropTypes.func.isRequired,
  fullDataReset: PropTypes.func, // Optional reset
};

export default QuickAndFullRangeDatePicker;
